import film1 from "../assets/videos/home1.webm";
import film2 from "../assets/videos/film22.webm";
import film3 from "../assets/videos/film44.webm";
import { cls } from "./Utility";
import logo from "../assets/logos/RG copy 2.png";
import DesktopWa from "./DesktopWa";
import Call from "./Call";

export default function Films() {
  return (
    <>
      <video
        className="w-full xl:h-[750px] h-[600px] object-cover"
        autoPlay
        loop
        muted
      >
        <source src={film1} type="video/mp4" />
      </video>

      <p
        className={cls(
          "text-[14px] font-[description1] pl-[20px] pr-[20px] text-center mt-[30px]",
          "xl:pl-p xl:pr-0"
        )}
      >
        True love meets cinematic magic
      </p>
      <div className="flex justify-center mb-[10px]">
        <img src={logo} className="w-[70px] h-[70px] object-contain" />
      </div>

      <div
        className={cls(
          "pl-[20px] pr-[20px] block mb-[30px] mt-[10px]",
          "xl:pl-0 xl:pr-0 xl:flex xl:flex-row xl:justify-center "
        )}
      >
        <video
          className="xl:w-[600px] xl:h-[700px] h-[600px] w-full object-cover"
          autoPlay
          loop
          muted
        >
          <source src={film3} type="video/mp4" />
        </video>
      </div>

      <p
        className={cls(
          "text-[25px] font-[Headings] pl-[20px] pr-[20px] text-center mt-[20px] font-semibold tracking-wider",
          "xl:pl-p xl:pr-0"
        )}
      >
        SOUL + LOVE
      </p>
      <p className="text-[12px] font-[description1]  mt-[30px] pl-[20px] pr-[20px] xl:pl-[380px] xl:pr-[280px] text-center mb-[30px]">
        Crafted with soulful storytelling and cinematic artistry, our films
        breathe life into every frame. Each moment is captured with love,
        creating timeless memories that echo with emotion.
      </p>

      <div
        className={cls(
          "pl-[20px] pr-[20px] block mb-[30px] mt-[40px]",
          "xl:pl-0 xl:pr-0 xl:flex xl:flex-row xl:justify-center "
        )}
      >
        <video
          className="xl:w-[600px] xl:h-[700px] h-[600px] w-full object-cover"
          autoPlay
          loop
          muted
        >
          <source src={film2} type="video/mp4" />
        </video>
      </div>
      <div className="chat-icon">
        <DesktopWa />
      </div>
      <div className="chat-icon1">
        <Call phoneNumber="9353624245" />
      </div>
    </>
  );
}
